export const ENDPOINT_USER_FIND_ALL = '/api/users/list';
export const ENDPOINT_USER_FIND_ONE = '/api/users/get-one';
export const ENDPOINT_USER_CREATE_ONE = '/api/users/create';
export const ENDPOINT_USER_RESET_PASSWORD = '/api/users/reset-password';
export const ENDPOINT_USER_UPDATE_ONE = '/api/users/update';
export const ENDPOINT_USER_DELETE_ONE = '/api/users/delete';
